<template>
  <div class="products-favorite row">
    <div class="col col-lg-12 col-md-12 col-sm-12">
      <h3 class="label-favorite mt-4">Mes produits préférés</h3>
      <div class="carousel__wrapper" :class="{ 'single-product': products.length === 1 }">
        <Carousel v-bind="config" ref="carousel" @slide-start="onSlideStart">
          <Slide v-for="product in products" :key="product.id">
            <ProductCardV2 :product="product" />
          </Slide>

          <template #addons v-if="shouldShowNavigation">
            <Navigation />
          </template>
        </Carousel>
      </div>
    </div>
    <h6 class="show-favorites">
      <router-link to="/dashboard/my-favorite-products">Voir mes favoris</router-link>
    </h6>
  </div>
</template>

<script>
  import ProductCardV2 from "./ProductCardV2.vue";
  import "vue3-carousel/carousel.css";
  import { Carousel, Slide, Navigation } from "vue3-carousel";

  export default {
    name: "ProductList",
    components: {
      ProductCardV2,
      Carousel,
      Slide,
      Navigation,
    },
    props: {
      products: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        currentSlide: 0,
        windowWidth: window.innerWidth,
        config: {
          itemsToShow: 3,
          snapAlign: "start",
          gap: 10,
          wrapAround: false,
          pauseAutoplayOnHover: true,
          autoplay: 0,
          breakpoints: {
            0: { itemsToShow: 1, snapAlign: "center", gap: 5 },
            600: { itemsToShow: 2, snapAlign: "start", gap: 8 },
            992: { itemsToShow: 3, snapAlign: "start", gap: 10 },
          },
        },
      };
    },
    computed: {
      shouldShowNavigation() {
        if (this.products.length <= 1) return false;

        // Calculer le nombre d'éléments visibles selon la taille d'écran
        let itemsToShow = 3; // Par défaut
        if (this.windowWidth < 600) {
          itemsToShow = 1;
        } else if (this.windowWidth < 992) {
          itemsToShow = 2;
        }

        return this.products.length > itemsToShow;
      },
      currentItemsToShow() {
        if (this.windowWidth < 600) return 1;
        if (this.windowWidth < 992) return 2;
        return 3;
      },
    },
    mounted() {
      console.log("Products passed to ProductList:", this.products);
      this.handleResize();
      window.addEventListener("resize", this.handleResize);

      // Configuration spéciale pour un seul produit
      if (this.products.length === 1) {
        this.config = {
          ...this.config,
          itemsToShow: 1,
          snapAlign: "center",
          gap: 0,
          autoplay: 0,
          breakpoints: {
            0: { itemsToShow: 1, snapAlign: "center", gap: 0 },
            600: { itemsToShow: 1, snapAlign: "center", gap: 0 },
            992: { itemsToShow: 1, snapAlign: "center", gap: 0 },
          },
        };
      }
    },
    beforeUnmount() {
      window.removeEventListener("resize", this.handleResize);
    },
    methods: {
      handleResize() {
        this.windowWidth = window.innerWidth;
      },
      onSlideStart(data) {
        this.currentSlide = data.currentSlideIndex;
      },
    },
  };
</script>

<style scoped>
  .carousel {
    --vc-nav-background: rgba(255, 255, 255, 0.9);
    --vc-nav-border-radius: 100%;
  }

  .carousel__wrapper {
    padding: 0 20px;
    position: relative;
    margin: 0 auto;
    width: 100%;
    max-width: 1200px;
    box-sizing: border-box;
  }

  .carousel__wrapper.single-product {
    padding: 0;
    display: flex;
    justify-content: center;
  }

  :deep(.carousel__track) {
    gap: 10px;
  }

  :deep(.carousel__viewport) {
    width: 100%;
    overflow: hidden;
  }

  :deep(.carousel__slide) {
    flex: 0 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
    min-width: 0;
    width: 33% !important;
  }

  :deep(.carousel__icon) {
    fill: #1e347d;
    height: 70%;
    width: auto;
  }

  :deep(.carousel__next),
  :deep(.carousel__prev) {
    border: 1px solid #1e347d !important;
    background: rgba(239, 241, 247, 0.95) !important;
    width: 45px !important;
    height: 45px !important;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
    border-radius: 50% !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    transition: all 0.3s ease !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  }

  :deep(.carousel__next:hover),
  :deep(.carousel__prev:hover) {
    background: rgba(201, 207, 222, 0.95) !important;
    transform: translateY(-50%) scale(1.05) !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  }

  :deep(.carousel__next--disabled),
  :deep(.carousel__prev--disabled) {
    opacity: 0.3 !important;
    cursor: not-allowed !important;
    background: rgba(239, 241, 247, 0.5) !important;
  }

  :deep(.carousel__next--disabled:hover),
  :deep(.carousel__prev--disabled:hover) {
    transform: translateY(-50%) !important;
    background: rgba(239, 241, 247, 0.5) !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  }

  :deep(.carousel__prev) {
    left: -80px !important;
  }

  :deep(.carousel__next) {
    right: -80px !important;
  }

  .label-favorite {
    color: #1e347d;
    font-weight: bold;
    margin-bottom: 40px;
    font-size: 24px;
  }

  .show-favorites {
    margin-top: 40px;
    text-align: center;
  }

  .show-favorites a {
    color: #1e347d;
    font-size: 16px;
    font-weight: bold;
    text-decoration: underline !important;
    transition: color 0.3s ease;
  }

  .show-favorites a:hover {
    color: #2c4ba0;
  }

  /* Responsive Design */
  @media (max-width: 1200px) {
    .carousel__wrapper {
      padding: 0 15px;
    }

    :deep(.carousel__prev) {
      left: -20px !important;
    }

    :deep(.carousel__next) {
      right: -20px !important;
    }
  }

  @media (max-width: 992px) {
    .carousel__wrapper {
      padding: 0 12px;
    }

    .label-favorite {
      font-size: 22px;
      margin-bottom: 30px;
      margin-top: 20px;
    }

    .show-favorites {
      margin-top: 30px;
    }

    .products-favorite {
      padding: 0 8px;
    }

    :deep(.carousel__next),
    :deep(.carousel__prev) {
      width: 40px !important;
      height: 40px !important;
    }

    :deep(.carousel__prev) {
      left: -15px !important;
    }

    :deep(.carousel__next) {
      right: -15px !important;
    }

    :deep(.carousel__icon) {
      height: 60%;
    }
  }

  @media (max-width: 768px) {
    .carousel__wrapper {
      padding: 0 8px;
    }

    :deep(.carousel__prev) {
      left: -12px !important;
    }

    :deep(.carousel__next) {
      right: -12px !important;
    }
  }

  @media (max-width: 600px) {
    .carousel__wrapper {
      padding: 0 5px;
    }

    .label-favorite {
      font-size: 18px;
      margin-bottom: 20px;
      margin-top: 15px;
    }

    .show-favorites {
      margin-top: 20px;
      font-size: 14px;
    }

    .show-favorites a {
      font-size: 14px;
    }

    .products-favorite {
      padding: 0 4px;
    }

    :deep(.carousel__next),
    :deep(.carousel__prev) {
      width: 35px !important;
      height: 35px !important;
    }

    :deep(.carousel__icon) {
      height: 50%;
    }

    :deep(.carousel__prev) {
      left: -8px !important;
    }

    :deep(.carousel__next) {
      right: -8px !important;
    }
  }

  @media (max-width: 480px) {
    .carousel__wrapper {
      padding: 0 2px;
    }

    .label-favorite {
      font-size: 16px;
      margin-bottom: 15px;
      margin-top: 10px;
    }

    .show-favorites {
      margin-top: 15px;
      font-size: 13px;
    }

    .show-favorites a {
      font-size: 13px;
    }
    :deep(.carousel__slide) {
      flex: 0 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: auto;
      min-width: 0;
      width: 100% !important;
    }
    :deep(.carousel__next),
    :deep(.carousel__prev) {
      width: 32px !important;
      height: 32px !important;
    }

    :deep(.carousel__prev) {
      left: -5px !important;
    }

    :deep(.carousel__next) {
      right: -5px !important;
    }
  }

  @media (max-width: 360px) {
    .carousel__wrapper {
      padding: 0;
    }

    :deep(.carousel__prev) {
      left: -2px !important;
    }

    :deep(.carousel__next) {
      right: -2px !important;
    }
  }
</style>
